var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input',_vm._b({attrs:{"type":"textarea"},on:{"focus":_vm.handleFocus,"blur":_vm.handleBlur},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}},'el-input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }